import { atom } from "recoil"

import type { SlideName } from "../Brochure/utils/useSlides"

export const brochureJumpToSlideState = atom<SlideName | null>({
  key: `brochureJumpToSlide`,
  default: null,
})
